import React, { useState, useEffect } from "react";
import { Table, Row, Col, Card, CardBody, CardTitle, CardSubtitle, Input, Label, Button, Form, Alert } from "reactstrap";
import { post, get, put } from "../../helpers/api_helper";
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Trans } from 'react-i18next';
import { Link, Route, useNavigate, useParams } from "react-router-dom";
import { ADD_ADDRESS, COUNTRIES_SEARCH, CITIES_SEARCH, DISTRICTS_SEARCH, SUBDISTRICTS_SEARCH, SHOW_ADDRESS, UPDATE_ADDRESS } from "helpers/api_endpoints";
import Select from "react-select";


//meta title
document.title = "Add Address";

const AddAddress = () => {

    const {id} = useParams();
    const [type, setType] = useState(1);
    const [status, setStatus] = useState(1);
    const [street, setStreet] = useState('');
    const [phone, setPhone] = useState('');
    const [title, setTitle] = useState('');
    const [countryId, setCountryId] = useState(183);
    const [cityId, setCityId] = useState(1);
    const [districtId, setDistrictId] = useState(1);
    const [subDistrictId, setSubDistrictId] = useState(1);
    const [building, setBuilding] = useState('');
    const [flatNo, setFlatNo] = useState('');
    const [longitude, setLongitude] = useState('54.385204');
    const [latitude, setLatitude] = useState('24.477559');
    const [cities, setCities] = useState([]);
    const [districts, setDistricts] = useState([]);
    const [subDistricts, setSubDistricts] = useState([]);
    const [countries, setCountries] = useState([]);
    const [errorMsg, seterrorMsg] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        if(id != '')
        {
            get(SHOW_ADDRESS+'/'+id)
                .then(response => {console.log(response.data.title)
                    setTitle(response.data.title);
                    setCountryId(response.data.countryId);
                    setCityId(response.data.cityId);
                    setDistrictId(response.data.districtId);
                    setSubDistrictId(response.data.subDistrictId);
                    setBuilding(response.data.building);
                    setFlatNo(response.data.flatNo);
                    setPhone(response.data.phone);
                    setStreet(response.data.street);
                    setLatitude(response.data.latitude);
                    setLongitude(response.data.longitude);
                })
                .catch(error => {
                    console.log('Loading Failed');
                })

        }
    }, [])

    useEffect(() => {
        post(CITIES_SEARCH)
            .then(response => {
                setCities(response.data.map(el=>{
                    return {value:el.id, label:el.nameTranslated, countryId:el.countryId}
                }));
            })
            .catch(error => {
                console.log('Loading Failed');
            })
        post(DISTRICTS_SEARCH)
            .then(response => {
                setDistricts(response.data.map(el=>{
                    return {value:el.id, label:el.nameTranslated, cityId:el.cityId}
                }));
            })
            .catch(error => {
                console.log('Loading Failed');
            })
        post(SUBDISTRICTS_SEARCH)
            .then(response => {
                setSubDistricts(response.data.map(el=>{
                    return {value:el.id, label:el.nameTranslated, districtId:el.districtId}
                }));
            })
            .catch(error => {
                console.log('Loading Failed');
            })
        post(COUNTRIES_SEARCH)
            .then(response => {
                setCountries(response.data.map(el=>{
                    return {value:el.id,label:el.nameTranslated}
                }));
            })
            .catch(error => {
                console.log('Loading Failed');
            })
    }, []);


    const handleSubmit = () => {console.log('id', id)
        console.log('id', id)
        if(id == '' || id == undefined)
            post(ADD_ADDRESS, { type, status, street, phone, title, countryId, cityId, districtId, subDistrictId, building, flatNo, longitude, latitude })
                .then(response => {
                    // console.log(response)
                    if (response.code == 201) {
                        navigate('/address', { state: { successMsg: 'Added SuccessFully' } });
                    }
                })
                .catch(error => {
                    seterrorMsg('Creation Failed');
                })
        else
            put(UPDATE_ADDRESS, { id, type, status, street, phone, title, countryId, cityId, districtId, subDistrictId, building, flatNo, longitude, latitude })
                .then(response => {
                    // console.log(response)
                    if (response.code == 200) {
                        navigate('/address', { state: { successMsg: 'Added SuccessFully' } });
                    }
                })
                .catch(error => {
                    seterrorMsg('Creation Failed');
                })

    }

    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Addresses" breadcrumbItem="Add" />
                    <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                            e.preventDefault();
                            handleSubmit();
                            return false;
                        }}
                    >
                        <Row>
                            <Col xl={12}>
                                <Card>
                                    <CardBody>
                                        <Row>
                                            {errorMsg ? <Alert color="danger">{errorMsg}</Alert> : null}
                                            <div className="form-group col-md-6 mt-2">
                                                <Label className="form-label"><Trans>Title</Trans></Label>
                                                <Input
                                                    name="title"
                                                    value={title}
                                                    className="form-control"
                                                    placeholder="Enter title"
                                                    type="text"
                                                    onChange={(e) => setTitle(e.target.value)}
                                                    required ></Input>
                                            </div>

                                            <div className="form-group col-md-6 mt-2">
                                                <Label className="form-label"><Trans>Country</Trans></Label>
                                                <Select
                                                    type="select"
                                                    value={countries.filter(el => el.value==countryId)}
                                                    options={countries}
                                                    onChange={e => setCountryId(parseInt(e.value))}
                                                    required
                                                />
                                            </div>

                                            <div className="form-group col-md-6 mt-2">
                                                <Label className="form-label"><Trans>City</Trans></Label>
                                                <Select
                                                    type="select"
                                                    value={cities.filter(el => el.value==cityId)}
                                                    options={cities}
                                                    onChange={e => setCityId(parseInt(e.value))}
                                                    required
                                                />
                                            </div>

                                            <div className="form-group col-md-6 mt-2">
                                                <Label className="form-label"><Trans>District</Trans></Label>
                                                <Select
                                                    type="select"
                                                    value={districts.filter(el => el.value==districtId)}
                                                    options={districts}
                                                    onChange={e => setDistrictId(parseInt(e.value))}
                                                    required
                                                />
                                            </div>

                                            <div className="form-group col-md-6 mt-2">
                                                <Label className="form-label"><Trans>Sub District</Trans></Label>
                                                <Select
                                                    type="select"
                                                    value={subDistricts.filter(el => el.value==subDistrictId)}
                                                    options={subDistricts}
                                                    onChange={e => setSubDistrictId(parseInt(e.value))}
                                                    required
                                                />
                                            </div>

                                            <div className="form-group col-md-6 mt-2">
                                                <Label className="form-label"><Trans>Street</Trans></Label>
                                                <Input
                                                    name="street"
                                                    value={street}
                                                    className="form-control"
                                                    placeholder="Enter Street"
                                                    type="text"
                                                    onChange={(e) => setStreet(e.target.value)}
                                                    required ></Input>
                                            </div>

                                            <div className="form-group col-md-6 mt-2">
                                                <Label className="form-label"><Trans>Building</Trans></Label>
                                                <Input
                                                    name="building"
                                                    value={building}
                                                    className="form-control"
                                                    placeholder="Enter building no"
                                                    type="text"
                                                    onChange={(e) => setBuilding(e.target.value)} required
                                                ></Input>
                                            </div>

                                            <div className="form-group col-md-6 mt-2">
                                                <Label className="form-label"><Trans>Phone</Trans></Label>
                                                <Input
                                                    name="phone"
                                                    value={phone}
                                                    className="form-control"
                                                    placeholder="Enter Phone"
                                                    type="text"
                                                    onChange={(e) => setPhone(e.target.value)} required
                                                ></Input>
                                            </div>
                                            <div className="form-group col-md-6 mt-2">
                                                <Label className="form-label"><Trans>Flat Number</Trans></Label>
                                                <Input
                                                    name="flatNo"
                                                    value={flatNo}
                                                    className="form-control"
                                                    placeholder="Enter Flat number"
                                                    type="text"
                                                    onChange={(e) => setFlatNo(e.target.value)} required
                                                ></Input>
                                            </div>
                                            <div className="form-group col-md-6 mt-2">
                                                <Label className="form-label"><Trans>Latitude</Trans></Label>
                                                <Input
                                                    name="latitude"
                                                    value={latitude}
                                                    className="form-control"
                                                    placeholder="Enter Latitude"
                                                    type="text"
                                                    onChange={(e) => setLatitude(e.target.value)} required
                                                ></Input>
                                            </div>
                                            <div className="form-group col-md-6 mt-2">
                                                <Label className="form-label"><Trans>Longitude</Trans></Label>
                                                <Input
                                                    name="longitude"
                                                    value={longitude}
                                                    className="form-control"
                                                    placeholder="Enter Longitude"
                                                    type="text"
                                                    onChange={(e) => setLongitude(e.target.value)} required
                                                ></Input>
                                            </div>
                                            {/* <div className="form-group col-md-6 mt-2">
                                                <Label className="form-label" for="typefrom"><Trans>Type : Pick up address</Trans></Label>
                                                <Input
                                                    id="typefrom"
                                                    name="type"
                                                    className="form-control"
                                                    type="radio"
                                                    value="1"
                                                    onChange={(e) => setType(e.target.value)} required
                                                ></Input>
                                                <Label className="form-label" for="typeto"><Trans>Type : Delivery address</Trans></Label>
                                                <Input
                                                    id="typeto"
                                                    name="type"
                                                    className="form-control"
                                                    type="radio"
                                                    value="2"
                                                    onChange={(e) => setType(e.target.value)} required
                                                ></Input>
                                            </div> */}
                                        </Row>
                                        <div className="text-center  mt-4">
                                            <Button type="submit" color="danger">
                                                <Trans>Submit</Trans>
                                            </Button>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </div>
        </React.Fragment>
    )
}

export default AddAddress
